import { render, staticRenderFns } from "./job_item.vue?vue&type=template&id=2d2150f2"
import script from "./job_item.vue?vue&type=script&lang=js"
export * from "./job_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports